"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaAnswerTrailListDisp = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _TrailDocumentValue = _interopRequireDefault(require("./components/TrailDocumentValue"));
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査証跡一覧画面（参照）
 */
class KansaAnswerTrailListDisp extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 監査証跡情報検索処理
     */
    _defineProperty(this, "searchTrailData", () => {
      const {
        callAPI,
        kansaInfo,
        openInfoBar,
        setSearchTrailResult
      } = this.props;
      callAPI(_APIs.KANSA_ANSWER_TRAIL_SEARCH, {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setSearchTrailResult(response.data);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
    if (this.props.searchTrailResult.length === 0) {
      // 監査証跡情報
      this.searchTrailData();
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl
    } = this.props;
    const createData = () => {
      let str = [];
      for (let i = 0; i < this.props.searchTrailResult.length; i++) {
        str.push({
          eviNo: this.props.searchTrailResult[i].eviNo,
          eviDocNm: this.props.searchTrailResult[i].eviDocNm,
          fileNm: this.props.searchTrailResult[i].fileNm
        });
      }
      return str;
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_TrailDocumentValue.default, {
      kansaInfo: this.props.kansaInfo,
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_TRAIL
      }),
      value: createData(),
      labelWidth: 150
    }))));
  }
}
exports.KansaAnswerTrailListDisp = KansaAnswerTrailListDisp;
const mapStateToProps = state => {
  return {
    kansaInfo: state.kansaAnswer.kansaInfo,
    searchTrailResult: state.kansaAnswer.searchTrailResult
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setSearchTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_TRAIL_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerTrailListDisp))));